<template>
  <JoszakiCard>
    <content-placeholders class="grid grid-cols-[auto_1fr] gap-2">
      <content-placeholders-img
        class="!h-9 !w-9 [clip-path:circle(50%_at_50%_50%)] float-right"
      />
      <div>
        <content-placeholders-heading />
        <content-placeholders-text :lines="2" />
      </div>
    </content-placeholders>
  </JoszakiCard>
</template>

<script>
export default {
  name: "CardAnswerPlaceholder",
};
</script>
